<template>
	<div>
		<el-dialog
			:close-on-click-modal="showClose"
			:show-close="showClose"
			:title="titleContent"
			:top="topContent"
			:visible.sync="isShowHint"
			:width="widthContent"
			center>
			<div>
				<slot name="content"></slot>
			</div>
			<template slot="footer">
				<el-button v-if="leftBtnContent !== ''" plain style="margin: 0 10px" type="primary" @click="onNoOrYes(0)">
					{{ leftBtnContent }}
				</el-button>
				<el-button v-if="rightBtnContent !== ''" style="margin: 0 10px" type="primary" @click="onNoOrYes(1)">
					{{ rightBtnContent }}
				</el-button>
			</template>
		</el-dialog>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

export default {
	name: 'baseHintDialog',
	mixins: [],
	components: {},
	props: {
		titleContent: {
			type: String,
			default: '提示',
		},
		widthContent: {
			type: String,
			default: '50%',
		},
		topContent: {
			type: String,
			default: '30vh',
		},
		showClose: {
			type: Boolean,
			default: false,
		},
		leftBtnContent: {
			type: String,
			default: '',
		},
		rightBtnContent: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			isShowHint: false,
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
	},
	watch: {},
	methods: {
		showHintDialog() {
			this.isShowHint = true
		},
		onHideDialog() {
			this.isShowHint = false
		},
		//0 不同意，1 同意
		onNoOrYes(type) {
			this.isShowHint = false
			this.$emit('onBaseDialogHint', type)
		},
	},
	created() {},
	mounted() {},
	activated() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
	beforeRouteEnter(to, from, next) {
		next()
	},
	beforeRouteUpdate(to, from, next) {
		next()
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
	padding: 15px 30px;
}

::v-deep .el-checkbox__label {
	margin-top: 4px;
}
</style>
